import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { AbsenceSalarieDto } from "../../../../../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieDto";
import { ActionAbsencesEnum } from "../../../../../../dto/GenApi.iNotPaie.Dto/ActionAbsencesEnum";
import { EtatAbsencesEnum } from "../../../../../../dto/GenApi.iNotPaie.Dto/EtatAbsencesEnum";
import { NotificationServiceInstance } from "../../../../../../shared/services/notification.service";
import { ParametresInstance } from "../../../../../Controls/Parameters";

@Component
export default class AnnulationEnAttente extends Vue {
	public colorCache: string[] = ["#1abc9c", "#2ecc71", "#3498db", "#9b59b6", "#34495e", "#16a085", "#27ae60", "#8e44ad", "#2c3e50", "#f1c40f", "#e67e22", "#e74c3c", "#95a5a6", "#f39c12", "#d35400", "#c0392b", "#bdc3c7", "#7f8c8d"];
	public curentOrberColumn = "DateDebut";
	public orderingDesc = false;

	@Prop()
	public annulationEnAttente: AbsenceSalarieDto[] = [];

	public validerAnnulationAbsence(absence: AbsenceSalarieDto): void {
		let action = ActionAbsencesEnum.AnnulerAbsenceParResponsableNiveau_1;
		if (absence.Etat === EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_2) {
			action = ActionAbsencesEnum.AnnulerAbsenceParResponsableNiveau_2;
		}
		else if (absence.Etat !== EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_1) {
			NotificationServiceInstance.SendWarning(`La demande d'absence ne peut pas être annulée car elle est ${ParametresInstance.getLibelleEtatAbsence(absence.Etat)}`);
			return;
		}
		this.$emit("afficherModalChangerEtatAbsence", absence, action);
	}

	public refuserAnnulationAbsence(absence: AbsenceSalarieDto): void {
		this.$emit("afficherModalChangerEtatAbsence", absence, ActionAbsencesEnum.RefuserAnnulationAbsenceParResponsable);
	}

	public randomColor(color: string): string {
		const r = () => Math.floor(256 * Math.random());

		return this.colorCache[color] || (this.colorCache[color] = `rgb(${r()}, ${r()}, ${r()})`);
	}

	public orderBy(columnName: string): void {
		if (this.curentOrberColumn == columnName) {
			this.orderingDesc = !this.orderingDesc;
		} else {
			this.orderingDesc = true;
		}

		this.curentOrberColumn = columnName;
		this.doOrder();
	}

	public doOrder(): void {
		const orderingDesc = this.orderingDesc;
		const columnName = this.curentOrberColumn;

		if (this.annulationEnAttente != undefined) {
			this.annulationEnAttente = this.annulationEnAttente.sort(function(a, b) {
				if (a[columnName] < b[columnName]) {
					return (orderingDesc ? -1 : 1);
				}
				if (a[columnName] > b[columnName]) {
					return (orderingDesc ? 1 : -1);
				}

				return 0;
			});
		}
	}

	public getClassOfOrder(columnName: string, desc: boolean): string {
		return (columnName == this.curentOrberColumn && this.orderingDesc == desc) ? "active" : "";
	}
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsences/listeDesDemandes/espaceManager/tableaux/annulationEnAttente/annulationEnAttente.ts